import {OwcProgressSpinner, OwcTypography } from '@one/react';
import React from 'react';
import {configData} from "../../config.js";
import '../../styles.scss';
import {fetchSigned} from "../../shared/Utilities.js"
import {getSublistDictionary, getItemforRefListId} from "./shared/SubListHelper.js"

/**
 * Renders a read only table of use case details
 *
 * @copyright Roche 2024
 * @author Nick Draper
 */
class SelectedReferenceList extends React.Component {
  /**
   * Constructor 
   * 
   * @param props The properties passed
   */
  constructor(props) {
    super(props);
    this.state = {isLoading:true};
  }

  /**
   * Runs once after construction after everything is initialised
   */
  componentDidMount() {
    if (this.props.refListsComplete === undefined || this.props.refListsComplete.length === 0) {
      // load the reference data
      fetchSigned(configData.REFDATA_API_URL + "?includeInactive=true")
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
              refDataList: result,
              isLoading: false,
            }
          );
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {this.setState({error})}
      );
    } else {
      this.setState({
        refDataList: this.props.refListsComplete,
        isLoading: false,
        });
    }
  }

  /**
   * Gets the description for a reference data id
   * @param {*} value the ref list id value
   * @param {*} refdataList the list to search in
   * @returns the description or null if not found
   */
  getDescriptionForRefData(value, refdataList) {
    let retVal = null;
    if (refdataList !== undefined) {
      const refDataItem = refdataList.find(({ refListId }) => refListId === value);
      //get the record
      if (refDataItem !== undefined) {
        retVal = refDataItem.description;
        if (refDataItem.isActive === false) {
          retVal += " (Deprecated)"
        }
      }
    }
    return retVal;
  }

  /**
   * looks up a ref data item and returns the string with an optional deprecation warning
   * @param {*} refListIdToLookup The id to look up
   * @param {*} alternateValue if not null this will be used for the ref data value
   * @param {*} includeDeprecationWarning if true and the ref list item is not active add a warning
   * @returns the strinbg desctrption of the ref data item, or null if it cannot be found
   */
  lookupRefData(refListIdToLookup, alternateValue = null, includeDeprecationWarning = true) {
    let retVal = alternateValue;
    if (this.state.isLoading===false) {
      const refDataEntry = this.state.refListsComplete.find(({ refListId }) => refListId === refListIdToLookup);
      if (refDataEntry !== undefined) {
        if (retVal === null) {
          retVal = refDataEntry.description;
        }
        if ((includeDeprecationWarning) && (!refDataEntry.isActive)) {
          retVal += configData.REFDATA_DEPRECATED;
        }
      }
    }
    return (retVal);
  }

  renderSelectedItem(id, sublist="", indent=false){
    return(
      <tr key={"renderSelectedItemRow"+sublist+id}>
        <td key={"renderSelectedItemCell"+sublist+id}>
          <OwcTypography key={"renderSelectedItemText"+sublist+id} variant={this.props.listTypographyVariant}
            style={indent?{paddingLeft:"3em"}:{}}
          >
            {this.getDescriptionForRefData(id, this.state.refDataList)}
          </OwcTypography>
        </td>
      </tr> 
    );
  }

  renderSublist(sublist, sublistDictItems) {
    console.log("renderSublist", sublist,sublistDictItems);
    return (
      <>
      <tr key={"renderSelectedSublistRow"+sublist}>
        <td key={"renderSelectedSublistCell"+sublist}>
          <OwcTypography key={"renderSelectedSublistText"+sublist} variant={this.props.listTypographyVariant}>
            {sublist===""?"No sublist":sublist}
          </OwcTypography>
        </td>
      </tr> 
        {sublistDictItems.map((refListItem)=>this.renderSelectedItem(refListItem.refListId, sublist, true))}
      </>
    );
  }

  /**
   * Renders the controls
   * @returns The JSX of the controls
   */
  render() {
    if (this.props.selectedRefDataList !== undefined && this.props.selectedRefDataList !== null) {
      if (this.state.isLoading) {
        return (<OwcProgressSpinner/>);
      } else {
        const selectedItems = this.props.selectedRefDataList.map((id)=>getItemforRefListId(id,this.state.refDataList));
        const sublistDict = getSublistDictionary(selectedItems, false);
        let noSublists = false;
        if (Object.keys(sublistDict).length===0) {
          noSublists = true;
        } else if (Object.keys(sublistDict).length===1 && Object.keys(sublistDict)[0]==="") {
          noSublists = true;
        }
        
        return (
          <table>
            <tbody>
            {this.props.hideTitle?
              ""
            :
              <tr><td><OwcTypography variant={this.props.listTypographyVariant} style={this.props.titleStyle}>{this.props.title}</OwcTypography></td></tr>
            }
            {(this.props.hideSublists===true || noSublists===true)?
              this.props.selectedRefDataList.map((id)=>this.renderSelectedItem(id))
            :
              Object.keys(sublistDict).map((sublist)=>this.renderSublist(sublist, sublistDict[sublist]))
            }
            </tbody>
          </table>
        );
      }
    }
  }

}

SelectedReferenceList.defaultProps = {
  selectedRefDataList: [],
  title: "Purpose Classification:",
  refListsComplete: [],
  hideSublists: false,
  hideTitle: false,
  removePadding: true,
  titleStyle: {fontWeight:"bold"},
  listTypographyVariant:"body",
}

export default SelectedReferenceList;
